import {Divider} from '@/components/ui/divider/Divider'
import {FormSectionLoader} from '@/components/commons/form-section/FormSectionLoader'

export const RenewProjectFormSectionsLoader = () => {
    return (
        <>
            <FormSectionLoader />
            <Divider direction="horizontal" />
            <FormSectionLoader />
            <Divider direction="horizontal" />
            <FormSectionLoader />
            <Divider direction="horizontal" />
            <FormSectionLoader />
        </>
    )
}
